module.exports = __webpack_public_path__ + "static/media/paperclip-2.eee0dd4f.svg";